"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    // FETCH
    function fetchRequest(id) {
        return {
            type: _ActionTypes.FETCH_REQUEST,
            payload: id
        };
    }
    function fetchSuccess(customer) {
        return {
            type: _ActionTypes.FETCH_SUCCESS,
            payload: customer
        };
    }
    function fetchFailed(error) {
        return {
            type: _ActionTypes.FETCH_FAILED,
            payload: error
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    return {
        fetchRequest,
        fetchSuccess,
        fetchFailed,
        clear
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map